// src/components/projects/ProjectsHero/ProjectsHero.jsx
import React from "react";
import { motion } from "framer-motion";
import {
  FiArrowUpRight,
  FiTrendingUp,
  FiHome,
  FiLayers,
} from "react-icons/fi";
import "./ProjectsHero.css";

export default function ProjectsHero() {
  return (
    <section className="pjh">
      <div className="pjh__bg" />
      <div className="pjh__overlay" />

      <div className="container pjh__container">
        <motion.div
          className="pjh__content"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          {/* Breadcrumb */}
          <div className="pjh__crumbs">
            <span>Home</span>
            <span className="pjh__sep">/</span>
            <strong>Projects</strong>
          </div>

          <h1 className="pjh__title">
            Explore High-Rise <br /> Projects
          </h1>

          <p className="pjh__sub">
            Discover premium vertical living — modern architecture, prime
            locations, and strong investment potential.
          </p>

          {/* Chips */}
          <div className="pjh__chips">
            <span className="pjh__chip">
              <FiLayers /> Pre-Launch
            </span>
            <span className="pjh__chip">
              <FiHome /> Ready
            </span>
            <span className="pjh__chip">
              <FiTrendingUp /> High ROI
            </span>
          </div>

          {/* CTA */}
          <div className="pjh__actions">
            <button className="pjh__btn pjh__btn--primary">
              View Projects <FiArrowUpRight />
            </button>

            <button className="pjh__btn pjh__btn--ghost">
              Talk to Advisor
            </button>
          </div>
        </motion.div>
      </div>

      {/* Bottom fade */}
      <div className="pjh__fade" />
    </section>
  );
}
